import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export function IconStopWatchFast({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
    >
      <g clipPath="url(#clip0_2747_18081)">
        <path
          d="M11.5582 6.58398H10.7694C10.5516 6.58398 10.375 6.76237 10.375 6.98242V11.498C10.375 11.7181 10.5516 11.8965 10.7694 11.8965H11.5582C11.776 11.8965 11.9526 11.7181 11.9526 11.498V6.98242C11.9526 6.76237 11.776 6.58398 11.5582 6.58398Z"
          fill={color}
        />
        <path
          d="M8.25132 9.6626H0V10.5259H4.34159C4.34816 10.6335 4.35704 10.7407 4.36821 10.847C4.40693 11.2014 4.47286 11.5523 4.56541 11.8965H6.21725C6.09589 11.5565 6.00954 11.2048 5.95958 10.847C5.94446 10.7407 5.93263 10.6337 5.92408 10.5259H8.25264L8.25132 9.6626Z"
          fill={color}
        />
        <path
          d="M7.40926 6.37549H2.96875V7.23877H4.93873C4.89491 7.33705 4.85284 7.43666 4.81253 7.5376C4.6228 8.01868 4.48763 8.51992 4.40959 9.03174H6.0118C6.11676 8.50886 6.2996 8.00509 6.55409 7.5376C6.60931 7.436 6.6677 7.33639 6.72927 7.23877H8.25227V6.37549H7.40926Z"
          fill={color}
        />
        <path
          d="M16.7491 6.10986L17.4919 5.35947C17.5286 5.32246 17.5578 5.27847 17.5777 5.23004C17.5976 5.18161 17.6079 5.12969 17.6079 5.07725C17.6079 5.02481 17.5976 4.97288 17.5777 4.92445C17.5578 4.87602 17.5286 4.83204 17.4919 4.79502L16.9332 4.23057C16.8965 4.19342 16.853 4.16395 16.805 4.14384C16.7571 4.12373 16.7057 4.11338 16.6538 4.11338C16.6019 4.11338 16.5505 4.12373 16.5026 4.14384C16.4546 4.16395 16.4111 4.19342 16.3744 4.23057L15.6941 4.91787C14.649 3.98012 13.3428 3.39108 11.954 3.23115V1.59424H12.8742C12.9788 1.59424 13.0791 1.55226 13.1531 1.47754C13.2271 1.40282 13.2686 1.30147 13.2686 1.1958V0.398926C13.2686 0.293254 13.2271 0.191909 13.1531 0.117188C13.0791 0.0424664 12.9788 0.000488281 12.8742 0.000488281L9.45616 0.000488281C9.35156 0.000488281 9.25124 0.0424664 9.17728 0.117188C9.10332 0.191909 9.06177 0.293254 9.06177 0.398926V1.1958C9.06177 1.30147 9.10332 1.40282 9.17728 1.47754C9.25124 1.55226 9.35156 1.59424 9.45616 1.59424H10.3764V3.23447C8.64573 3.43643 7.0571 4.2996 5.93622 5.64701H8.28876C9.12103 5.0978 10.0903 4.79817 11.0843 4.78285C12.0783 4.76754 13.0562 5.03717 13.9046 5.56048C14.7531 6.0838 15.4373 6.83936 15.878 7.73956C16.3188 8.63975 16.4979 9.64771 16.3946 10.6466C16.2913 11.6454 15.9099 12.5942 15.2946 13.383C14.6793 14.1718 13.8553 14.7682 12.9181 15.1031C11.981 15.438 10.969 15.4977 9.99963 15.2753C9.03024 15.0528 8.14313 14.5573 7.44115 13.8462C7.44115 13.8462 7.21897 13.637 7.13714 13.4786H8.25228V12.6841H2.96875V13.5474H5.2434C5.30125 13.6487 5.36161 13.7484 5.42449 13.8462C6.04413 14.8148 6.8942 15.6109 7.897 16.162C8.8998 16.713 10.0233 17.0013 11.1649 17.0005C14.9412 17.0005 18.001 13.9093 18.001 10.0942C18.0033 8.66702 17.5658 7.27446 16.7491 6.10986Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2747_18081">
          <rect width="18" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
